'use client'

import { THomepageData, TWidgetSetting } from '@/types/home'
import { createContext, useContext } from 'react'

interface SettingContextType {
  homeSetting: THomepageData | null
  widgetSetting: TWidgetSetting | null
}

export const SettingContext = createContext<SettingContextType>({
  homeSetting: null,
  widgetSetting: null,
})

export const SettingProvider = ({
  children,
  homeSetting,
  widgetSetting,
}: {
  children: React.ReactNode
  homeSetting: THomepageData | null
  widgetSetting: TWidgetSetting | null
}) => {
  return (
    <SettingContext.Provider value={{ homeSetting, widgetSetting }}>
      {children}
    </SettingContext.Provider>
  )
}

export const useSettingData = () => {
  const { homeSetting } = useContext(SettingContext)
  return homeSetting
}

export const useWidgetSettingData = () => {
  const { widgetSetting } = useContext(SettingContext)
  return widgetSetting
}
